function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#373A36;}\n\t.st1{fill:#9C4877;}\n\t.st2{fill:#F8F8F7;}\n\t.st3{fill:#E2E2DC;}\n\t.st4{fill:#E64B38;}\n\t.st5{fill:#EFB8A9;}\n\t.st6{fill:none;stroke:#CCCCCC;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:#FFC557;}\n\t.st8{fill:none;stroke:#373A36;stroke-width:0.4213;stroke-miterlimit:10;}\n\t.st9{fill:#4A9462;}\n\t.st10{fill:none;stroke:#F8F8F7;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M27.8,0H4.541C2.037,0,0,2.037,0,4.541V27.8c0,2.503,2.037,4.54,4.541,4.54L27.8,32.341 c2.503,0,4.541-2.037,4.541-4.541V4.541C32.34,2.037,30.303,0,27.8,0z M31.84,27.8c0,2.229-1.812,4.041-4.041,4.041l-9.102,0V18.514 h6.135v-0.5h-6.135v-5.984c0-1.989,1.618-3.607,3.607-3.607H24.9v-0.5h-2.595c-2.265,0-4.107,1.843-4.107,4.107v5.984h-4.827v0.5 h4.827V31.84L4.541,31.84c-2.228,0-4.041-1.812-4.041-4.04V4.541C0.5,2.312,2.312,0.5,4.541,0.5H27.8 c2.228,0,4.041,1.812,4.041,4.041V27.8z"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.34 32.341",
    style: {
      enableBackground: "new 0 0 32.34 32.341"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.2296addb.svg";
export { ForwardRef as ReactComponent };